import { gql } from '@apollo/client';

export const ADD_STATUS = gql`
  mutation addStatus($values: StatusInput!) {
    addStatus(values: $values) {
      id
      name
      description
      color
    }
  }
`;

export const UPDATE_STATUS = gql`
  mutation updateStatus($values: UpdateStatusInput!) {
    updateStatus(values: $values) {
      id
      name
      description
      color
    }
  }
`;

export const DELETE_STATUS = gql`
  mutation deleteStatus($id: ID!) {
    deleteStatus(id: $id)
  }
`;
